const API_BASE =
  (process.env.REACT_APP_API_URL || 'http://localhost:4000').replace(/\/$/, '');

const API_URL = API_BASE + '/api';

const api = {
  // Auth
  signup: async (email, password, name) => {
    const response = await fetch(`${API_URL}/auth/signup`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password, name }),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.message || error.errors?.[0]?.msg || 'Signup failed');
    }
    return response.json();
  },

  login: async (email, password) => {
    const response = await fetch(`${API_URL}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.message || error.errors?.[0]?.msg || 'Login failed');
    }
    return response.json();
  },

  getCurrentUser: async (token) => {
    const response = await fetch(`${API_URL}/auth/me`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) throw new Error('Failed to get user');
    return response.json();
  },

  // Site Config
  getSiteConfig: async (token) => {
    const response = await fetch(`${API_URL}/site-config`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) throw new Error('Failed to get site configuration');
    return response.json();
  },

  saveSiteConfig: async (token, siteUrl, backendUrl, siteDescription, selectedHoneypots) => {
    const body = { siteUrl, backendUrl, siteDescription };
    if (selectedHoneypots && selectedHoneypots.length > 0) {
      body.selectedHoneypots = selectedHoneypots;
    }
    const response = await fetch(`${API_URL}/site-config`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.message || 'Failed to save site configuration');
    }
    return response.json();
  },

  // Attack Data (NEW)
  getEvents: async (token, limit = 200) => {
    const response = await fetch(`${API_URL}/events?limit=${limit}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) throw new Error('Failed to get events');
    return response.json();
  },

  getSessions: async (token, limit = 200) => {
    const response = await fetch(`${API_URL}/sessions?limit=${limit}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) throw new Error('Failed to get sessions');
    return response.json();
  },

  getTraps: async (token, limit = 200) => {
    const response = await fetch(`${API_URL}/traps?limit=${limit}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) throw new Error('Failed to get traps');
    return response.json();
  },

  getStats: async (token) => {
    const response = await fetch(`${API_URL}/stats`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) throw new Error('Failed to get stats');
    return response.json();
  },
};

export default api;
